export default __webpack_public_path__ + "img/e0925aad33b0af75b6753ec9a6f5cb6c.svg";